





































import { defineComponent, reactive, watch } from '@vue/composition-api'

export default defineComponent({
  name: 'AnswerInputTable',
  props: {},
  setup(_, context) {
    const state = reactive({
      defectReason: '',
      messageToAdmin: '',
    })
    watch(state, () =>
      context.emit('update', state.defectReason, state.messageToAdmin),
    )
    return { state }
  },
})
